import React from 'react';
import { AppBar, Container, Stack, Typography } from '@mui/material';

interface TitleBarProps {
  title: string;
  subtitle?: string;
  zIndex?: number;
}

export const TitleBar: React.FC<TitleBarProps> = ({ title, subtitle, zIndex }) => {

  return (
    <AppBar position='relative' elevation={0} sx={{ zIndex: zIndex }}>
      <Container maxWidth='xl'>
        <Stack justifyContent='center' sx={{ paddingY: { xs: 4, sm: 5 } }}>
          <Typography sx={{ typography: { xs: 'h4', sm: 'h3' } }}>{title}</Typography>
          <Typography sx={{ typography: { sm: 'h5' } }}>{subtitle}</Typography>
        </Stack>
      </Container>
    </AppBar>
  );
};